// AI Generated Test
import { Component, Input } from '@angular/core';

@Component({
    selector: 'page-fix-changeset-spelling',
    standalone: false,
    template: `
        <span class="label label-info">{{data?.change?.value}}</span>
    `,
})
export class PageFixChangesetSpellingComponent {
    @Input() data: any;
}
